import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import type {
  WorkIntegration_Keys,
  WorkIntegrationInstance,
} from '@/common/api/types/workIntegrations';
import { IntegrationInstancesAPI } from '@/features/settings/work-integrations/api/instances';
import { workIntegrationsQueryKeys } from '@/features/settings/work-integrations/queryKeys';

export const useGetIntegrationInstances = (
  sourceSystemType?: WorkIntegration_Keys,
  options?: Omit<UseQueryOptions<WorkIntegrationInstance[], Error>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery({
    queryKey: workIntegrationsQueryKeys.integrationInstances.list(sourceSystemType),
    queryFn: () => IntegrationInstancesAPI.getInstances(sourceSystemType),
    ...options,
  });
};
